var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 832.8 224.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#radial-gradient34);\n      }\n\n      .st1 {\n        fill: url(#radial-gradient33);\n      }\n\n      .st2 {\n        fill: url(#radial-gradient32);\n      }\n\n      .st3 {\n        fill: url(#radial-gradient30);\n      }\n\n      .st4 {\n        fill: url(#radial-gradient31);\n      }\n\n      .st5 {\n        fill: url(#radial-gradient23);\n      }\n\n      .st6 {\n        fill: url(#radial-gradient22);\n      }\n\n      .st7 {\n        fill: url(#radial-gradient20);\n      }\n\n      .st8 {\n        fill: url(#radial-gradient26);\n      }\n\n      .st9 {\n        fill: url(#radial-gradient25);\n      }\n\n      .st10 {\n        fill: url(#radial-gradient24);\n      }\n\n      .st11 {\n        fill: url(#radial-gradient27);\n      }\n\n      .st12 {\n        fill: url(#radial-gradient21);\n      }\n\n      .st13 {\n        fill: url(#radial-gradient28);\n      }\n\n      .st14 {\n        fill: url(#radial-gradient29);\n      }\n\n      .st15 {\n        fill: url(#radial-gradient16);\n      }\n\n      .st16 {\n        fill: url(#radial-gradient17);\n      }\n\n      .st17 {\n        fill: url(#radial-gradient12);\n      }\n\n      .st18 {\n        fill: url(#radial-gradient15);\n      }\n\n      .st19 {\n        fill: url(#radial-gradient18);\n      }\n\n      .st20 {\n        fill: url(#radial-gradient10);\n      }\n\n      .st21 {\n        fill: url(#radial-gradient19);\n      }\n\n      .st22 {\n        fill: url(#radial-gradient13);\n      }\n\n      .st23 {\n        fill: url(#radial-gradient11);\n      }\n\n      .st24 {\n        fill: url(#radial-gradient14);\n      }\n\n      .st25 {\n        fill: #231f20;\n      }\n\n      .st26 {\n        fill: #6e6f71;\n      }\n\n      .st27 {\n        fill: url(#radial-gradient);\n      }\n\n      .st28 {\n        fill: #1c3864;\n      }\n\n      .st29 {\n        fill: #929497;\n      }\n\n      .st30 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st31 {\n        fill: url(#radial-gradient6);\n      }\n\n      .st32 {\n        fill: url(#radial-gradient9);\n      }\n\n      .st33 {\n        fill: url(#radial-gradient8);\n      }\n\n      .st34 {\n        fill: url(#radial-gradient3);\n      }\n\n      .st35 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st36 {\n        fill: url(#radial-gradient5);\n      }\n\n      .st37 {\n        fill: url(#radial-gradient4);\n      }\n\n      .st38 {\n        fill: url(#radial-gradient7);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    gradientTransform: "translate(-36.8) scale(1.1 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e5c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c3864"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cy: 142.9,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient4",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient5",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient6",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient7",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient8",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient9",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient10",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient11",
    cy: 142.9,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient12",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient13",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient14",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient15",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient16",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient17",
    cx: 678.2,
    fx: 678.2,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient18",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient19",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient20",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient21",
    cy: 142.9,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient22",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient23",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient24",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient25",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient26",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient27",
    cy: 142.9,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient28",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient29",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient30",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient31",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient32",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient33",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient34",
    cx: 678.2,
    cy: 142.9,
    fx: 678.2,
    fy: 142.9,
    r: 37.6,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M152.4,111.5s-2.3,6.1-3.2,9.2c2,2.5,3.2,5.2,4.3,7.6-5.6,3.9-13.8,3.8-15.9-2-.8-2-1.2-4.3-.8-7.6.7-2.8-1.6-2-3.4,0-1.5,1.5-2.5,3.1-3.9,5.3-7,10.6-19.7,11.8-23.4,1.9-1.2-2.8-1.8-11.3-2.2-16-1.8-23.3-2.1-61.6-9.5-79-.3-.6-.4-.6-.6,0-1.4,3-2.3,5.6-3.3,7.8,6,22.8,5.6,47.5,7.3,72.9.3,4.1,1,13.4,2.2,17.4,4.2,17.1,20.9,15.7,28.6,4.4,1.3-1.9,1.6-2.2,3.1-4.2.8-.9.9-.9.9,0,.2,3,1.2,6.2,3,8.1,3.8,4.4,12.3,3.4,17.1.2,2.2-1.5,3.7-5.7,4.3-8.9.7-4.4.8-9.4-4.5-17.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M79.4,99.4c-3.5.9-5.7,1.5-8,2.2-.9-1.8-2.5-4-3.7-5.5,3.1-4.9,10.8,2.3,11.8,3.3ZM71.7,84.5c-5.6,1.8-8,9.1-6.9,13.6.5,2.1,1.1,2.9,2.2,4.9-8.6,3.1-16.7,6.7-23.7,12.7-10.7,9.1-15,19.5-24.7,28.5-6,5.7-15.2,4.6-16.6-5.9-.6-6.6,2.3-12.4,5.8-19.4,1.5-3.1.2-3.1-1.2-.6C3.1,124.8-.2,130.7,0,138.3c.3,14.8,14,20.9,23.1,11.6,9.1-9,12.3-16.8,21.2-25.4,8.5-8.1,18.4-11.8,26.4-14,.6,1.4,1.9,5,2.1,5.2.5,1.2,1.3-.3,1.5-1.5.2-1.4.2-3.6-.2-4.8,2.1-.5,9.9-2.2,12.7-2.7,1.3-.4,5.1-8.5,3.1-10.5-2.5-3.3-12.2-13.7-18.1-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M136.3,34.3c-.3,3.7-.5,10-.5,10,0,0,1.5.6,2.1,1.4,5.3,9.2,8.9,14.4,14.8,22.4,16.4,22.5,36.2,40.3,41.1,51.3,2.8,5.1,4.1,10.4,3.9,14.2,0,1.7.2,1.8.8.7.4-1.5,2.5-6.8.5-16.2-3.1-16.4-26.1-36.2-40.9-55-3.4-4.3-6.1-8.1-8.8-12.2-.5-.8-.9-1.6,0-1.3,1.6.6,3.5,1.2,5.1,1.9,2.1.8,1.9-.7-.3-2.7-8.4-7.2-12.9-10.8-17.7-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M197.1,27.3c-1.3,2.4-3.6,7.4-4.1,8.6,1,1.2,1.2,2.1,1.4,2.8.2,3.9.6,8.3.9,12.2,1.7,22.6,8.6,58.3,8.9,78.4-6.4,13.4-22.1,22-32.2,29.3-2.8,1.7-4.8,3.1-1.2,2.1,5.2-1.2,18.3-5.1,22.1-8,.9-.7,8.6-5.1,13.1-17.9.7-1.9,2.1-7,2.7-11.4,3.2-22.1-6.6-56.1-7.1-73.5,0-1.4.6-.9.6-.9,0,0,2.9,3.3,3.9,4.5,1.1,1.3,1.8,0,.7-3-2.2-6-6.9-16.7-9.2-22.9,0-.2-.3-.7-.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M468.3,117c-2.4-.4-8.8,1-9.7-1.1.4-1.2,1.7-2.9,3.6-3.2,1.7-.1,3.9,1.1,6.1,4.2ZM480.4,126.9c-.2-5.9-1.9-13-7.4-19.1-7.1-7.9-13.7-4.2-16.9.8-4.8,6.9-3.9,13.2-1.4,16.4,3.8,5,12.6.1,18.2,2.7,1.6.8,3.8,3.1,4.3,5-2.6,3.9-25.7,16.9-29.3-2.4-1-4-2.1-15.2-2.4-18-1-8.6-7.5-75.5-11.3-84.2-1.4,2.3-3,6.5-3.7,9.2,2.1,21.5,6.4,53.7,7.8,75.8.1,1.6.6,8.4.4,10-1.2,3.9-29.4,30.3-48.3,31.7-7.2.5-16.4-2.2-19.8-9.3-3-6.6-1.7-13.8,1-22.7,1.6-5.1-.1-5.3-1.5-1.4-3.9,9.8-5.6,19.7-3.6,27.8,2.6,10.7,12.1,16.4,22.6,15.3,15.1-1.5,33.7-14.9,46.3-28.3,2.9-2.9,3.9-7.4,4.7-11.9.3-1.6.5-2.3.6-1.2.2,3.8,1.5,12.2,2.2,15.3,5.5,22.1,30,8.2,34.3,2.7,2-2.3,3.4-8.7,3.3-14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M414.2,100.8c0-15.5-4.5-31.2-5.9-48.3,0-.5-.3-2.7.1-3.2.5,0,2.4,2.8,3.5,4.3,1.2,1.7,1.9-.4.8-3.7-.7-2.1-7.8-21.2-8.7-22.5-.7.7-4,7.9-4.4,8.7,1,1.3,1.1,1.7,1.2,2.6,2.3,34.4,6.2,42.6,8.3,75.2-5.8,6.8-33.9,13.4-39.7,18.3-10.6,6.9-16.7,17.5-24.5,23.8-8,6.5-16.6,2.1-16.4-7.6.1-5.7,4.9-13.5,7.1-17.3,1.5-2.7.5-2.8-.9-.7-2.1,3.2-7.4,11.2-7.9,18-1.4,12.5,8.9,21.9,18.9,15.9,6.9-4.8,12.8-12.8,19.8-19.9,7.4-8.9,33.6-12.7,41.8-20.3,7.1-5.8,6.8-21.1,6.8-23.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M320.1,103.9c1.4,8.7,9,21.1,17,21.7,7.6-.8,22.7-12.1,24.9-14.4-.2,2.1-1.3,5.9-2.9,8.4-4.8,5.7-19,15.2-27.9,17-12,1.8-20.2-5-23.5-16.7-4.3-18.2-3.7-62.9-10-84.9.8-2,2.3-5.2,3.6-8.4.2-.7.4-.2.6,0,6.1,16.9,8,62.3,10,80.4,1.8,16.7,10.6,19.5,10.6,19.5-5.8-6.7-9.6-16.4-4.4-25.6,7-12.4,23.3-11.6,32-4,.9.8,1.6,1.6,1.9,2,.4.6.8,1.5,0,1.2-.8-.7-3.3-1.3-4-1.4-9-1.7-21.6,1.2-27.9,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M296,124.5c0-5.3-2-11.8-8.5-18.6-1.5,4.8-1.8,7.4-2.4,10,2.3,2.8,7.1,8.9,7.6,11-2.8,2.6-12.2,8.7-18.4,3.5-2.8-2-5.8-9.4-7.5-12.9-1.7-3.2-4-4.5-6.9-3.1-6,3-9.5,9.7-10.8,11.9-3.9,6.8-5,13.9-7.2,18.6-3.6,8.1-10.2,6.2-13.1,1-2.8-5.1-4.2-15.1-4.4-18.1,0-2.7-1.8-4.3-1.7,1,.2,10.1,2.3,16.9,4,20.9,1.9,5,9,12.8,15.3,3.7,3.7-5.3,4.4-13.5,9.4-21.7,5-7.6,10-9.2,11.8-6.4,1.2,1.5,3.9,9.4,6.1,12.1,4.5,6.9,17.5,6.1,24-1.7,1-.8,2.7-5.8,2.7-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M235,48.7c1.2,3.8.4,4.9-.7,3.7-1.4-1.6-3-3.9-4.4-5.1-.3.5-.2,1.3-.2,2.2,2.8,30.9,5.8,42.2,7,68.4,0,8.4-.7,15.3-3.5,22.2-.9,2.3-1.7,2.8-1.7,1.1,0-5.2-.9-18.9-1.1-22.1-1.8-27.2-5.9-47-7.6-79.4,0-1-.2-2.5-.2-3.5-.4-1.1-.4-1.1-.9-2,.3-.6,2.8-5.2,4-7.6.4-.9.7-1,1.1,0,2.4,6.6,7.2,18.8,8.2,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M536.9,129.6c-4.9,6.9-16.5,13.3-24.4,14.7-1.4.2-10.8,1-13.7-8.5-2.4-5.8-3.4-32.3-4.4-44.5,0-.9.4-.6,1.3,0,15.4,11.8,35.2,24.8,41.2,38.2ZM581.6,117.5c-3.1,15.4-18.9,18.4-28.2,5.2-16.6-23.7-46.6-33.8-54.8-38.8,0-.2,1-1.1,1.7-1.7,11-8.6,44.2-26.7,60.9-32,4.5-1.8,9.8-.6,8.2,3.9-4,4.7-12.6,14.8-15.1,20.2-1.1,2.4-1,4,1.1.7,4.1-6.8,9.2-10.5,14.9-19.4,5.1-7,5.5-17.9-4-15.4-15.5,3-63.6,28.5-69.2,36.5-.9,1.4-2.3,5.1-2.6,5.6-.3.8-.7.8-.9-.7-.4-4.9-4.8-44.4-8.4-53.4l-4.4,8.5c3.9,15.3,8.4,69.8,9.2,82.1.6,9.8,1.3,18,2.1,21.1,2,9.3,7.7,14.8,16.7,14.6,7.1-.3,17.8-5.5,26.2-13.1,2.8-2.5,4.7-6.9,4.6-13.6-.8-8.7-5.6-13.1-7.3-15.5-.3-.4-.8-.7,0-.1,8.7,4.5,19.7,21.5,23.1,24.2,7.8,6.9,18.6,4.2,23.7-3,2-2.2,4-9.4,3.5-13.4-.1-1.1-.6-2.5-1.1-2.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M175.1,132.5c-2,0-3.5-2.8-3.1-4.7.6-3.5,2.6-7,3.9-10.2.8-1.9,1.1-4.7-1-.5-1.3,2.5-3.4,6.3-4.8,10.3-.7,1.9-.9,3.8-.7,5.5.4,2.8,3.1,5.6,5.8,2.8,1.4-1.5,2.2-3.8,2.6-5.4.4-1.7.3-1.5-.7-.5-.6,1-1.1,2.1-1.9,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M84.8,138.1c2.6.5,3.9,4.4,3,6.9-1.6,4.4-5,8.6-7.4,12.4-1.4,2.3-2.5,5.8,1.2.9,2.3-3,5.8-7.4,8.6-12.2,1.3-2.3,2.1-4.7,2.2-6.9.1-3.8-2.7-8-6.9-4.9-2.1,1.6-3.7,4.4-4.7,6.4-.9,2.1-.8,1.9.9.8,1-1.1,1.9-2.5,3.1-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M183.2,70.8c-2,0-3.6-2.6-3.3-4.6.5-3.5,2.3-7.2,3.4-10.4.7-1.9.9-4.7-1-.4-1.2,2.6-3.1,6.4-4.3,10.5-.6,1.9-.8,3.8-.4,5.5.5,2.8,3.4,5.5,5.9,2.5,1.3-1.5,2-3.9,2.4-5.5.3-1.7.3-1.5-.8-.5-.5,1-1,2.2-1.7,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M32.9,62.5c.8-2.8,2.3-5.9,5.1-4.9,1.8.7,5.4,3.7,6,5.9.2,1.1-.4,2.4-1.1,4.2-2.8-.5-9.7,3.3-10,4-.3,1.9,8.3,18.8,6.8,31-.2,2-1.1,3.7-1.1,1.3,0-10.4-3.1-16.3-6.3-26.6-1-3.2-1.1-7.5,1.3-9.8,1.4-1.3,3.1-2.4,6.3-3.1-2.7-2.6-4.9-3.2-6.3-.7-.9,1.5-1.4,1-.7-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M29.9,47.7c-1-.9-4.4-2.5-5.2-2.7,0-.3,0-3.3.6-4.7.6-1.5,1.4-1.3,3-.5,3.7,2.1,6.2,6.3,7.8,11.2.6,1.9.4,1.2.5-.7.1-3.9.3-8.1,2.2-11.6,1.8-3.2,4.9-3,6.7.4l-1.2,3.6c-.5-1-1.9-1.9-2.8-2.2-3.4-.6-3.4,7-3.6,9-.2,2.7-.2,5.4-1.5,8-.3.5-.7.4-1-.4-1.7-5-3-8.6-5-10.4-.3.2-.2.3-.6,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M111.1,45.3c-1-.9-4.4-2.5-5.2-2.7,0-.3,0-3.3.6-4.7.6-1.5,1.4-1.3,3-.5,3.7,2.1,6.2,6.3,7.8,11.2.6,1.9.4,1.2.5-.7.1-3.9.3-8.1,2.2-11.6,1.8-3.2,4.9-3,6.7.4l-1.2,3.6c-.5-1-1.9-1.9-2.8-2.2-3.4-.6-3.4,7-3.6,9-.2,2.7-.2,5.4-1.5,8-.3.5-.7.4-1-.4-1.7-5-3-8.6-5-10.4-.3.2-.2.3-.6,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M246.2,43.4c-1-.9-4.4-2.5-5.2-2.7,0-.3,0-3.3.6-4.7.6-1.5,1.4-1.3,3-.5,3.7,2.1,6.2,6.3,7.8,11.2.6,1.9.4,1.2.5-.7.1-3.9.3-8.1,2.2-11.6,1.8-3.2,4.9-3,6.7.4l-1.2,3.6c-.5-1-1.9-1.9-2.8-2.2-3.4-.6-3.4,7-3.6,9-.2,2.7-.2,5.4-1.5,8-.3.5-.7.4-1-.4-1.7-5-3-8.6-5-10.4-.3.2-.2.3-.6,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M174.2,35.8l-1.4,1.8c0-.8-.4-1.5-1-2.2-1.2-1.2-3.8-.2-5.5,1.4,1.1,2.1,6.1,3.4,8.6,2.4,3-1.3,3.8-1.8,5.5-2.7l-1.8,4.4c-6.1,3-9.5,4.8-16,8.3,0,0,.5-2,1.4-4.3,1.2-.7,4-2.2,4-2.2-1.6-.5-4.5-1.6-5.1-3.5-1-3,7.4-11.5,10.2-8.6,1.1,1.2,1.5,3.7,1,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M140.3,61.2c-18.1,7.5-18.1,7.2-29.2,12.3-.8.7-2.4,3.8-2.8,4.7-.1.2,0,.4.2.3.2-.2.5-.5.9-.8,7.1-3.9,18.3-8,28.2-12l2.8-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M15.7,114.9c-3.7,0-6.7-4.8-6.2-8.4.8-6.6,4.1-13.2,6.2-19.3,1.2-3.5,1.6-8.7-1.9-.8-2.2,4.8-5.6,11.9-7.9,19.4-1.1,3.6-1.4,7.1-.8,10.1,1,5.2,6.2,10.1,10.9,4.5,2.4-2.9,3.7-7.2,4.3-10.3.6-3.1.5-2.8-1.4-.9-1,1.9-1.8,4-3.2,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M436.4,162.2c-1.9,0-3.5-2.5-3.3-4.4.4-3.4,2.1-6.9,3.2-10.1.6-1.8.8-4.5-1-.4-1.2,2.5-3,6.2-4.1,10.1-.6,1.9-.7,3.7-.4,5.3.5,2.7,3.3,5.3,5.7,2.4,1.3-1.5,1.9-3.7,2.3-5.4.3-1.6.2-1.5-.7-.4-.5,1-.9,2.1-1.7,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M483.4,150.9c1.9.6,2.6,3.4,1.7,5.2-1.5,3.1-4.2,5.9-6.2,8.6-1.2,1.6-2.2,4.1.8.7,1.9-2,4.7-5,7-8.4,1.1-1.6,1.8-3.3,2-4.9.3-2.7-1.5-6-4.7-4-1.7,1-3,3-3.8,4.4-.8,1.5-.7,1.3.6.7.8-.8,1.5-1.7,2.5-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M365.6,48.5c-2.5,0-4.4-3.1-4.1-5.6.5-4.3,2.7-8.8,4.1-12.7.8-2.3,1-5.7-1.3-.5-1.5,3.2-3.7,7.9-5.2,12.8-.7,2.4-.9,4.7-.5,6.7.7,3.4,4.1,6.7,7.2,3,1.6-1.9,2.4-4.7,2.9-6.8.4-2.1.3-1.9-.9-.6-.7,1.2-1.2,2.7-2.1,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M283.8,53.2c-2.5,0-4.4-3.1-4.1-5.6.5-4.3,2.7-8.8,4.1-12.7.8-2.3,1-5.7-1.3-.5-1.5,3.2-3.7,7.9-5.2,12.8-.7,2.4-.9,4.7-.5,6.7.7,3.4,4.1,6.7,7.2,3,1.6-1.9,2.4-4.7,2.9-6.8.4-2.1.3-1.9-.9-.6-.7,1.2-1.2,2.7-2.1,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M72,63.9c-2.9,0-5.3-3.8-4.9-6.7.6-5.2,3.2-10.5,4.9-15.3,1-2.8,1.2-6.9-1.5-.6-1.8,3.8-4.5,9.4-6.3,15.4-.9,2.8-1.1,5.6-.6,8,.8,4.1,5,8,8.6,3.6,1.9-2.3,2.9-5.7,3.4-8.1.5-2.5.4-2.2-1.1-.7-.8,1.5-1.4,3.2-2.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M554.7,159.4c-2.1-.2-3.5-3.2-3-5.3.9-3.7,3.3-7.3,4.9-10.6,1-1.9,1.5-4.9-1-.6-1.6,2.6-4.1,6.4-5.9,10.5-.9,2-1.3,4-1.2,5.8.2,3,2.8,6.2,5.9,3.4,1.6-1.5,2.6-3.8,3.2-5.6.6-1.8.5-1.6-.8-.6-.7,1-1.3,2.2-2.2,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M213.5,159.1c-1.6,0-2.9-2-2.7-3.5.3-2.8,1.6-5.7,2.4-8.2.5-1.5.6-3.7-.8-.3-.9,2.1-2.3,5.1-3.2,8.3-.4,1.5-.5,3-.2,4.3.5,2.2,2.8,4.2,4.7,1.8,1-1.2,1.5-3.1,1.7-4.4.2-1.3.2-1.2-.6-.4-.4.8-.7,1.7-1.3,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M392.3,50.5c-17,6-54.6,20.9-70,27.3-1.2,1.2-2.6,4.1-3.1,5.3-.1.3,0,.3.1.2.2-.2.5-.4.8-.6,8.9-4.3,61-24.3,69.3-27.3l2.8-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M586.2,65.2c-16.7,6.8-30.4,13-45.5,20.1-1.1,1.3-2.4,4.3-2.9,5.4-.1.3,0,.3.1.2.2-.2.5-.5.8-.6,8.7-4.7,36.6-16.7,44.8-20l2.6-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M544.7,25.6c-16.4,7.4-29.9,14.1-44.7,21.7-1.1,1.3-2.2,4.3-2.7,5.5-.1.3,0,.3.2.2.2-.2.4-.5.8-.7,8.6-5,36-18.1,44.1-21.7l2.4-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M294.1,81.8c-16.8,6.5-30.6,12.5-45.9,19.3-1.1,1.3-2.5,4.2-3,5.4-.1.3,0,.3.1.2.2-.2.5-.4.8-.6,8.8-4.5,36.9-16.1,45.2-19.3l2.7-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M375,89.5c-1-.9-4.4-2.5-5.2-2.6,0-.3,0-3.3.6-4.7.6-1.5,1.4-1.3,3-.5,3.7,2.1,6.2,6.3,7.8,11.2.6,1.8.4,1.2.5-.7.1-3.9.3-8.1,2.2-11.6,1.8-3.2,4.8-3,6.7.4l-1.1,3.6c-.5-1-1.9-1.9-2.8-2.2-3.4-.6-3.4,7-3.6,8.9-.2,2.7-.2,5.4-1.5,7.9-.3.5-.7.4-1-.4-1.7-5-3-8.5-5-10.4-.3.2-.2.3-.6,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "461.9 74.7 456.3 82.5 465.4 89.3 471.1 81.6 461.9 74.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "571.4 92.6 565.8 100.5 574.9 107.3 580.6 99.6 571.4 92.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "300.7 146.7 295.1 154.5 304.2 161.3 309.8 153.7 300.7 146.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "249.2 67.7 243.7 75.6 252.9 82.3 258.5 74.6 249.2 67.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "148 147.8 142.5 155.7 151.7 162.3 157.3 154.6 148 147.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "556.7 93.5 551.1 101.4 560.2 108.1 565.9 100.5 556.7 93.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "285.9 147.5 280.4 155.4 289.5 162.2 295.1 154.5 285.9 147.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "128.4 88.6 123.4 96.8 132.9 102.9 138 94.9 128.4 88.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "113.8 90.5 108.8 98.7 118.3 104.8 123.4 96.8 113.8 90.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "263.9 66.7 258.4 74.6 267.6 81.3 273.2 73.6 263.9 66.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "133.2 148.8 127.8 156.8 137 163.4 142.5 155.7 133.2 148.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M462.8,42.8h0c1-3.7-.5-8.7-4.6-6.4-1,.6-1.6,1.1-.8,2.3,1.1,1.7,4.6,3.4,5.5,4.1M461,47.1c-2.4-1.6-6.3-3.1-6.6-6.2-.4-3.2,3.2-7.6,6-8.9,4.8-2.1,7.8,4.1,4.2,12,1,.7,1.6,1.3,2,2,.8,1.5.2,3-.4,5.2-.5-1.2-1.6-2.2-3.7-3.5-7.4,13.3-21.3,22.1-31.9,29.2-5.4,3.6-5.6,2.7-1.2-.9,11.4-9.5,23.4-17,31.6-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M462.8,42.8h0c1-3.7-.5-8.7-4.6-6.4-1,.6-1.6,1.1-.8,2.3,1.1,1.7,4.6,3.4,5.5,4.1M461,47.1c-2.4-1.6-6.3-3.1-6.6-6.2-.4-3.2,3.2-7.6,6-8.9,4.8-2.1,7.8,4.1,4.2,12,1,.7,1.6,1.3,2,2,.8,1.5.2,3-.4,5.2-.5-1.2-1.6-2.2-3.7-3.5-7.4,13.3-21.3,22.1-31.9,29.2-5.4,3.6-5.6,2.7-1.2-.9,11.4-9.5,23.4-17,31.6-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M462.8,42.8h0c1-3.7-.5-8.7-4.6-6.4-1,.6-1.6,1.1-.8,2.3,1.1,1.7,4.6,3.4,5.5,4.1M461,47.1c-2.4-1.6-6.3-3.1-6.6-6.2-.4-3.2,3.2-7.6,6-8.9,4.8-2.1,7.8,4.1,4.2,12,1,.7,1.6,1.3,2,2,.8,1.5.2,3-.4,5.2-.5-1.2-1.6-2.2-3.7-3.5-7.4,13.3-21.3,22.1-31.9,29.2-5.4,3.6-5.6,2.7-1.2-.9,11.4-9.5,23.4-17,31.6-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M462.8,42.8h0c1-3.7-.5-8.7-4.6-6.4-1,.6-1.6,1.1-.8,2.3,1.1,1.7,4.6,3.4,5.5,4.1M461,47.1c-2.4-1.6-6.3-3.1-6.6-6.2-.4-3.2,3.2-7.6,6-8.9,4.8-2.1,7.8,4.1,4.2,12,1,.7,1.6,1.3,2,2,.8,1.5.2,3-.4,5.2-.5-1.2-1.6-2.2-3.7-3.5-7.4,13.3-21.3,22.1-31.9,29.2-5.4,3.6-5.6,2.7-1.2-.9,11.4-9.5,23.4-17,31.6-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M462.8,42.8h0c1-3.7-.5-8.7-4.6-6.4-1,.6-1.6,1.1-.8,2.3,1.1,1.7,4.6,3.4,5.5,4.1M461,47.1c-2.4-1.6-6.3-3.1-6.6-6.2-.4-3.2,3.2-7.6,6-8.9,4.8-2.1,7.8,4.1,4.2,12,1,.7,1.6,1.3,2,2,.8,1.5.2,3-.4,5.2-.5-1.2-1.6-2.2-3.7-3.5-7.4,13.3-21.3,22.1-31.9,29.2-5.4,3.6-5.6,2.7-1.2-.9,11.4-9.5,23.4-17,31.6-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M462.8,42.8h0c1-3.7-.5-8.7-4.6-6.4-1,.6-1.6,1.1-.8,2.3,1.1,1.7,4.6,3.4,5.5,4.1M461,47.1c-2.4-1.6-6.3-3.1-6.6-6.2-.4-3.2,3.2-7.6,6-8.9,4.8-2.1,7.8,4.1,4.2,12,1,.7,1.6,1.3,2,2,.8,1.5.2,3-.4,5.2-.5-1.2-1.6-2.2-3.7-3.5-7.4,13.3-21.3,22.1-31.9,29.2-5.4,3.6-5.6,2.7-1.2-.9,11.4-9.5,23.4-17,31.6-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M462.8,42.8h0c1-3.7-.5-8.7-4.6-6.4-1,.6-1.6,1.1-.8,2.3,1.1,1.7,4.6,3.4,5.5,4.1M461,47.1c-2.4-1.6-6.3-3.1-6.6-6.2-.4-3.2,3.2-7.6,6-8.9,4.8-2.1,7.8,4.1,4.2,12,1,.7,1.6,1.3,2,2,.8,1.5.2,3-.4,5.2-.5-1.2-1.6-2.2-3.7-3.5-7.4,13.3-21.3,22.1-31.9,29.2-5.4,3.6-5.6,2.7-1.2-.9,11.4-9.5,23.4-17,31.6-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M69.7,140.2c-18.6,7.7-23.1,8.8-34.2,14.1-.8.7-2.1,3.2-2.5,4.1-.1.2,0,.4,0,.3.2-.2.3-.3.7-.6,7.1-3.9,23.9-9.6,33.4-13.8l2.5-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M274,150.6c-18.9,8.5-17.3,7-29.6,13-.8.7-2.2,3.3-2.5,4.2-.1.2,0,.4,0,.3.2-.2.3-.3.7-.6,7.1-3.9,19.4-8.4,28.9-12.6l2.5-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M462.8,42.8h0c1-3.7-.5-8.7-4.6-6.4-1,.6-1.6,1.1-.8,2.3,1.1,1.7,4.6,3.4,5.5,4.1M461,47.1c-2.4-1.6-6.3-3.1-6.6-6.2-.4-3.2,3.2-7.6,6-8.9,4.8-2.1,7.8,4.1,4.2,12,1,.7,1.6,1.3,2,2,.8,1.5.2,3-.4,5.2-.5-1.2-1.6-2.2-3.7-3.5-7.4,13.3-21.3,22.1-31.9,29.2-5.4,3.6-5.6,2.7-1.2-.9,11.4-9.5,23.4-17,31.6-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M322,29.6l.4,5.1c8,5.1,15.2,17.2,13.2,26.9,0,.6.5,1,1.2-1.2,2.9-11.2-4.6-26.5-14.9-30.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M148.4,90.6c-.7,1-1.6,3.3-.8,4.1,1.1,1,4.1.4,4.9-.6.2-.3.3-.3,0-.6-.7-.9-3-2.5-4.1-2.9M148.8,85.3c.4-1.5,1.2-.9,1.1.2,0,.5-.4,1.8-.6,2.3,3.9,2,6.1,3.5,4.4,7.9-1,2.7-6.3,4.5-7.8,1.2-1.6-3.3,1.5-7.3,2.9-11.6Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M727.8,78.9l-10.3-65.5s-.7-8.5-10.3-7.6c-9.6.9-8.7,8.5-8.3,12.6.4,4,9,50.1,9,50.1l20,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M704,67l-10.8-54.8s-1.4-13.1-8.3-12.2c-5.8.8-11.6,2.2-11.1,11.5.5,9.3,14.8,65.2,14.8,65.2,0,0,.9-12.7,15.4-9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M678.8,62.9s11.2,34.9,11.4,36.8c.2,1.9,2.1,8.2-6.9,10.6-9,2.3-12.7-12.5-12.7-12.5l-7.8-23.1s-4.4-10,7.1-14c0,0,7-2.6,9,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M656.2,79.6l14.9,31.6s2.5,5.1-5.8,7c0,0-5.2,0-8.8-4.8-3.5-4.9-12.1-22.9-12.1-22.9,0,0-.8-14.4,11.8-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M705.2,72.9l23.7,11.9,15.3,24s6.6,7.4.9,17.6c-5.7,10.2-19.2,35.4-19.2,35.4l2.8,31.5-62.4-.6v-31.1c.1,0,7.9,6.1,19.6,8.8,0,0-21.6-11.4-26.6-18.7-7.1-10.3-9.6-38.3-9-42.9,0,0,6.8,18,18.6,15.4,8-1.8,5.9-6.5,11.8-6.2,5.9.3,19.3-5,16.1-16.4,0,0-3.7-11.8-5.6-14.2,0,0,15.5,9,17.6,11.2,2.2,2.2,3.6,10.2.1,19.1,0,0,3.9-1.6,5-5.3.6-2.1,4.3-13.4,4.3-13.4l-20.5-11.3s-4.5-4.7-2.8-9.7c1.8-5.6,7.9-6.1,10.1-5.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M832.8,213.1c-34.5-9.9-82.2-16-134.9-16s-100.4,6.1-134.9,16c34.5-16.7,82.2-27,134.9-27s100.4,10.3,134.9,27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M685.5,128s0,0,0,0c-4.1.7-8.1,1.7-11.9,3-.4.1-.7.3-1.1.4-.3.1-.7.2-1,.4-3.9,1.6-7.4,3.5-10.6,6,1-.6,1.9-1.1,2.9-1.7.3-.2.7-.3,1-.4.9-.3,1.9-.6,2.8-1,2.5-1,5.1-2.1,7.6-3.1,1.8-.7,3.6-1.3,5.4-1.8,1.5-.4,3-.7,4.6-.8.4,0,.6-.1.6-.5,0-.3,0-.5-.4-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M721.3,146.5s0,0,0,0c-1.1-2.2-2.4-4.4-3.8-6.5-1.5-2.2-3.2-4.3-5.3-6.1-.2-.2-.4-.3-.7-.3-1-.2-1.7-.8-2-1.6-.1-.4-.3-.8-.5-1.1-.3-.5-.7-.7-1.3-.5-.3,0-.5.1-.8.2,0-.1,0-.2,0-.3-.2-1-.8-1.8-1.6-2.4-.7-.5-1.4-.9-2.2-1.2-2-.8-4.1-1.3-6.3-1.6-.1,0-.2,0-.3,0-.6.5-1.3,1-2.1,1.4.3,0,.7,0,1,0,2.1,0,4.2.3,6.2,1,1.1.4,2.1.9,2.9,1.6.2.1.3.3.5.5,0,0,0,0,0,.1-.2,0-.4,0-.6,0-.4,0-.8-.1-1.3-.2-.7-.1-1.4-.3-2-.4-.3,0-.6,0-.9,0-.3,0-.4.2-.3.4.1.3.3.4.7.5,2,.5,3.9,1.1,5.7,2,4.2,2.1,7.5,4.9,10,8.5.3.4.6.9.9,1.3,1.8,2,2.6,4.3,2.8,6.8.4-.6,1-1.2,1.6-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M733.7,126.4c.3-.5.6-1,.9-1.5,0-.1-.1-.3-.2-.4-.2-.4-.3-.9-.6-1.2-1.9-1.9-3.8-3.9-5.8-5.8-1.9-1.9-4.1-3.5-6.6-4.8-.1,0-.2-.1-.3-.2-.5-.4-.9-.8-1.4-1.2-.1.2-.3.4-.4.5,0,.4-.2.7-.3,1.1,1.4,1,2.9,1.9,4.3,2.9,2.3,1.5,4.5,3.2,6.4,5.1,1.2,1.1,2.3,2.3,3,3.7.3.6.6,1.2.9,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M722.4,139.8c.6,1.8,1,3.6,1,5.4,0,0,.1,0,.2,0,0-.9.3-1.9.6-2.7-.2-.8-.5-1.5-.7-2.3-.7-1.8-1.5-3.5-2.5-5.2-1.4-2.3-3-4.6-5.2-6.4-.5-.4-1-.9-1.5-1.3-3.6-3-7.7-5.3-12.1-7.3-.6.3-1.2.5-1.9.7.7.3,1.3.5,2,.8,1.7.7,3.5,1.3,4.9,2.5,0,0,.1,0,.2.1,2,1.1,3.9,2.4,5.6,3.8,2.7,2.2,5,4.7,7,7.4,1.1,1.4,1.9,2.9,2.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M716.3,145.8c.6,1.3.7,2.7.5,4.1.4-.2.9-.4,1.4-.5,0-.3,0-.5,0-.8,0-.6,0-1.2-.2-1.7-.2-.3-.3-.7-.4-1-.8-1.9-1.9-3.7-3.2-5.4-1.9-2.5-4.2-4.6-7.2-6.2-1.2-.6-2.4-1.1-3.6-1.7-.2,0-.4-.2-.7-.2-.2,0-.5,0-.7,0-.6,0-.9.5-.7,1,.1.3.4.6.7.7.4.2.9.4,1.3.5,1.9.5,3.6,1.3,5.1,2.3,2.3,1.6,4.2,3.5,5.6,5.7.7,1,1.4,2.1,1.9,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M695.6,145.4c2.7,0,5,.7,6.8,2.4.7.7,1.2,1.4,1.3,2.3,0,.8,0,1.5-.4,2.3-.4,1-1.1,1.9-1.9,2.7-1.4,1.6-3.1,2.9-4.7,4.3-.1.1-.3.2-.4.3-1.6.8-3.1,1.8-4.6,2.8-.7.5-1.4,1.1-2.1,1.7.4,0,.9.1,1.3.2.8-.5,1.8-.8,2.9-1,2.3-1.6,4.5-3.2,6.6-5,2.1-1.8,3.9-3.8,5.2-6.1.1-.2.2-.4.3-.6.1-.6,0-1.1,0-1.7-.2-1.1-.8-2-1.6-2.8-1.5-1.6-3.5-2.6-5.8-3.1-.8-.2-1.7-.3-2.5-.3-3,.2-6,.9-8.9,1.6-2.1.6-4.1,1.2-6.2,1.7-.9.2-1.3.8-1.6,1.5-.1.3,0,.6.4.6.2,0,.5,0,.7,0,1.5-.1,2.8-.6,4-1.3.3-.2.6-.3.9-.4.2,0,.3,0,.5-.1,1.8-.5,3.6-1,5.4-1.5,1.5-.4,3.1-.7,4.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M730.8,131.1c-.2-.3-.3-.6-.5-1-1.9-3.2-4.2-6.1-7.1-8.6-.2-.2-.5-.4-.7-.5-.8-.6-1.7-1.1-2.5-1.6-1.1-.7-2.1-1.5-3.2-2.2-.4.4-.9.8-1.4,1.1,0,0,.1.1.2.2.2,0,.3.2.5.3,3.5,2,6.7,4.3,9.4,7.2,1.7,1.8,3.2,3.8,4.2,6,.3-.3.7-.5,1.1-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M710.4,145.8c-.1-.7-.3-1.4-.8-2-2.2-2.5-4.9-4.4-8.2-5.7-2-.8-4.1-1.2-6.4-1,.1.2.3.3.4.5.3.2.6.4.9.5.9.4,1.8.7,2.6,1.1,1.6.6,3.2,1.2,4.7,2,.9.5,1.8,1,2.5,1.7,0,.1.2.2.4.3,1.7,1,2.4,2.3,2.4,4.1,0,1.2-.4,2.3-.9,3.4-.6,1.3-1.3,2.6-1.8,3.9-.4,1-1.1,1.9-1.9,2.7-.6.6-1.2,1.3-1.9,1.8-1.5,1.4-3.2,2.6-4.9,3.8-.2.1-.4.3-.6.4.6,0,1.2.1,1.7.2.8-.4,1.6-.8,2.5-1,2-1.6,4-3.4,5.6-5.3.2-.2.3-.4.4-.6.5-1.1,1-2.2,1.4-3.3.5-1.2,1-2.4,1.5-3.6.5-1.3.6-2.6.4-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M708.3,126.7c-.3-.3-.6-.6-.9-.9-.7-.4-1.4-.8-2.1-1.2-1.7-.8-3.4-1.5-5.1-2.2-.2,0-.4-.2-.6-.3-.3-.2-.6-.4-.9-.5-.3.6-.6,1.1-1,1.6,1.4.3,2.8.8,4.1,1.3,2.1.9,4.1,1.8,6.1,2.8.1,0,.3.1.4.2.2-.3.1-.5,0-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M714.8,151.3c0,0,0-.1,0-.2.4-1.2.4-2.5.1-3.7-.3-1.1-.7-2.2-1.4-3.2-1-1.6-2.3-3.1-3.7-4.5-.3-.3-.6-.5-.9-.8-4.4-3.2-9.4-5-15-5.8-1.5-.2-3-.4-4.5-.3-3.1.1-6.1.8-9,1.7-3,.9-5.9,2.1-8.8,3.3-.2,0-.4.2-.4.4,0,.2-.1.4-.1.6,0,.4.2.6.7.6.3,0,.7,0,1-.2,1-.4,2.1-.9,3.1-1.3.8-.4,1.6-.8,2.6-.9.2,0,.5-.1.7-.2,1.6-.5,3.1-1,4.7-1.5,2-.6,4.1-1,6.2-1.1,2-.1,4,0,5.9.7.6.2,1.2.4,1.8.5,1.9.5,3.7,1,5.5,1.8,1.9.8,3.6,1.8,5,3.1.3.3.6.6.9.8,2.1,1.9,3.6,4.1,4.1,6.7.3,1.5,0,3-.6,4.5,0,.1-.1.3-.4.4-.3-.5-.2-1-.4-1.5-.1-.5,0-1-.4-1.6-.9,3.5-2,6.9-4.4,9.9.4.2.7.2,1.1.1.4-.1.8-.2,1.2-.5.5-.4,1.1-.8,1.5-1.2.4-.4.8-.9,1.1-1.3.3-2.1,1.2-4,2.8-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M726.2,139.5c-.7-1.5-1.3-3-2-4.5-.3-.5-.6-1.1-.9-1.6-.1-.2-.3-.4-.7-.5,0,.2-.1.4-.1.6,0,1.1.4,2.2,1,3.1.8,1.2,1.4,2.5,1.9,3.8.3-.3.5-.7.8-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M699.3,147.8c-.8-.3-1.6-.5-2.5-.6-2.5-.2-5,.1-7.4.9-.5.2-1,.4-1.5.7-.2.2-.5.3-.7.4-1.2.4-2.4.9-3.6,1.3-1,.4-2,.7-2.9,1.2-.4.2-.8.5-1.1.8-.4.4-.4.8,0,1.2.2,0,.5-.1.7-.2,1.2-.3,2.4-.8,3.6-1.3,1.8-.8,3.6-1.6,5.4-2.4,1.8-.8,3.7-1.3,5.8-1.5,1.2,0,2.3,0,3.3.5,1.1.5,1.6,1.3,1.4,2.4-.1.5-.3,1-.6,1.5-1.3,2-3.1,3.6-5.4,4.6-.1,0-.3.1-.4.2-2,1.4-4.1,2.8-6.1,4.2-1.7,1.2-3.3,2.5-4.9,3.8.2,0,.3.2.5.3.9-.5,1.8-.9,2.8-1.2.3,0,.6,0,1-.1.1-.1.3-.2.4-.3.2-.1.3-.2.4-.4,1.2-1.1,2.5-2.1,3.9-3,1.7-1.1,3.4-2.1,5-3.2,1.7-1.2,3.3-2.5,4.4-4.1.5-.7.7-1.5.8-2.3,0-1.5-.7-2.6-2.2-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M732.9,128.7c-.3-.8-.7-1.6-1.1-2.3-1.7-3-4.1-5.6-7.2-7.6-.7-.4-1.5-.8-2.1-1.3-1.3-.9-2.6-1.9-4-2.9-.2.4-.4.8-.7,1.1.6.4,1.3.9,1.9,1.3,2.5,1.7,4.9,3.5,7,5.5,1.7,1.7,3.2,3.6,4.3,5.7.4.7.7,1.4,1.1,2.1.2,0,.4-.1.6-.2,0-.5,0-1.1.2-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M729.4,106.3c-.2-.6-.3-1.1-.4-1.6-.7-.6-1.5-1.1-2.3-1.6-1.3-.8-2.9-1.3-4.6-1.2-.1,0-.2,0-.4,0,0,0,0,.1.1.1,1.4.8,2.7,1.8,4,2.8,1.4,1,2.7,2.1,4.2,3-.2-.5-.4-1-.6-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M734.9,119.4c-.7-.7-1.4-1.4-2.1-2.1-1.2-1.2-2.5-2.4-3.9-3.4-.5-.3-1-.6-1.5-1,0,0,0,0-.1,0,.3.9.6,1.8,1.4,2.4,1.3,1.3,2.7,2.5,4,3.8,1.1,1.1,2.3,2.1,3.4,3.2-.4-1-.8-2.1-1.2-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M696.5,149.9c-.2-.3-.3-.3-.9-.2-2.8.6-5.5,1.6-8.1,2.7-4.5,2-8.5,4.7-12.1,7.7.6.3,1.2.6,1.7.9.4-.2.8-.5,1.2-.8,1.5-1.1,3-2.1,4.5-3.2,1.9-1.3,4-2.5,6.3-3.2.1,0,.2-.1.3-.2.5-.3.9-.6,1.4-.8,1.2-.5,2.3-.9,3.5-1.3.7-.2,1.3-.5,1.8-.9.3-.3.4-.6.2-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M657,144.9c1-.8,2-1.6,3-2.3,2.6-1.8,5.4-3.4,8.2-4.9,3.5-1.8,7.2-3.3,11-4.5,1-.3,2-.6,3-.9,1.2-.4,2.4-.6,3.7-.8,1.9-.2,3.9-.2,5.8,0,2.3.1,4.7.3,7,.5.3,0,.6,0,1,0-.2-.1-.2-.2-.3-.2-.9-.5-1.9-.9-3-1.1-2.3-.5-4.6-.6-6.9-.5-1.9,0-3.9.4-5.8.7-2.2.4-4.3.9-6.3,1.7-1.8.7-3.6,1.4-5.4,2.1-1.7.7-3.4,1.4-5,2.2-2.6,1.2-5,2.6-7.3,4.2-1.2.8-2.4,1.7-3.5,2.7.3.4.5.9.8,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M691.7,154.7c-.3.1-.5.2-.7.3-2.2,1-4.3,2.2-6.3,3.6-2,1.4-3.8,2.8-5.6,4.3.3.3.6.7.9,1,.1.2.3.4.5.6.8-.6,1.7-1.1,2.6-1.6.1,0,.2-.2.3-.3.1-.8.6-1.5,1.4-2,.6-.4,1.2-.8,1.9-1.2,1.1-.6,2.2-1.1,3.3-1.7.5-.3,1-.7,1.5-1.1.6-.6.7-1.3.3-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M723.8,126.7c-2.9-3-6.2-5.5-9.9-7.7-.6.2-1.2.4-1.8.6,2.2,1.1,4.2,2.3,5.9,4,.9.9,1.9,1.8,2.9,2.7.6.5,1.2,1,1.9,1.4.2.2.5.3.7.3.3.1.5,0,.6-.3,0-.4-.1-.6-.4-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M684.6,141.1c0,0-.2,0-.3,0-2.3.6-4.6,1.3-6.9,1.9-1.6.4-3.2.7-4.7,1.1-.3,0-.5.2-.7.4-.3.4-.8.4-1.2.2-.4-.3-.7-.7-.9-1.1,0-.2,0-.3.2-.4,1-.6,2-1.3,3-1.9,2.5-1.5,5.1-2.6,8-3.5,1.4-.4,2.8-.7,4.2-1.1.3,0,.5-.2.8-.3.7-.3,1.4-.5,2.1-.5,1.3,0,2.5.2,3.7.6.3.1.6.3.8.4.2.2.2.4-.1.4-.4.1-.8.2-1.2.2-1.1,0-2.1,0-3.2.1-2.1.1-4.1.5-6.2,1-1.9.5-3.8,1.1-5.7,1.8-.1,0-.3.1-.4.2,0,0-.2,0-.2.2-.3.6.2,1.3,1,1.3.7,0,1.4-.3,2-.5,1.1-.4,2.2-.9,3.3-1.3.4-.1.8-.3,1.2-.3,1.1-.2,1.6.3,1.3,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M688.4,142.6c-.1.3-.4.4-.7.5-.9.3-1.7.6-2.6.9-2.9.9-5.9,1.7-8.8,2.9-2,.8-3.9,1.8-5.5,3.1-.1.1-.3.2-.4.4-.9.9-2,1.1-3.2,1.2-.3,0-.7,0-.8-.3-.2-.3,0-.5.3-.8,2.1-2.3,4.7-3.9,7.7-5,1.7-.6,3.5-1.1,5.3-1.5.7-.1,1.3-.3,2-.5,1.9-.6,3.9-1,5.9-1.2.3,0,.6,0,.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M661.5,151.4c1.5-.8,3-1.6,4.3-2.6,1-.7,2-1.4,2.8-2.2.2-.2.4-.5.5-.7.2-.4,0-.7-.4-.9-.3-.1-.6-.2-.9-.2-.3,0-.5,0-.7.2-1.2.8-2.4,1.7-3.6,2.5-1.1.8-2.2,1.6-3.3,2.4.4.6.8,1.1,1.2,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M659.2,148.2c.4-.3.7-.5,1-.8,1-.8,1.9-1.6,2.8-2.4.8-.6,1.7-1.2,2.6-1.8.5-.3,1.1-.6,1.8-.6,1-.2,1.9-.6,2.6-1.3.2-.2.4-.4.5-.6.3-.5,0-.9-.6-.8-.4,0-.9.1-1.3.2-.8.2-1.4.6-2,1-2.3,1.3-4.5,2.5-6.6,4-.7.5-1.3,1-1.9,1.5.4.6.8,1.2,1.2,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M667.2,158c.2,0,.5,0,.7,0,0,0,0-.1,0-.2.5-1.3,1.4-2.4,2.7-3.3.8-.5,1.7-1,2.5-1.4,1.1-.6,2.2-1.2,3.2-1.8.5-.3.8-.7,1.3-1-.5-.4-1.1-.6-1.7-.6-1,0-1.9.2-2.8.6-2.1.9-3.9,2.3-5.3,4-.7.8-1.2,1.7-1.5,2.7,0,0,0,0,0,0,.3.3.6.6.8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M709.7,128c.7.1,1.3.4,1.8.8,1.4.8,2.4,1.9,3.4,3.1.9,1.1,1.8,2.3,2.8,3.4.4.5.9.9,1.4,1.3.7.6,1.1,1.3,1.5,2.1.5,1,.8,2,1.1,3.1,0,.2,0,.5,0,.7,0,.1,0,.3,0,.4-.4,0-.5-.1-.6-.3-.4-.6-.9-1.2-1.1-1.8-.7-1.6-1.7-3.1-2.9-4.5-1.3-1.5-2.7-2.9-4-4.3-1-1.1-1.9-2.2-2.8-3.3-.2-.2-.3-.5-.5-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M731.5,111.2c-1.5-1.3-3.1-2.4-5-3.3-.2,0-.4-.2-.6-.2,0,0,0,0-.1,0,0,.2.1.4.2.6.3.6.7,1.1,1.2,1.6.6.5,1.2,1,1.8,1.5,1.4,1.1,2.7,2.2,4,3.5-.5-1.2-1.1-2.5-1.6-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M709.6,120.8c.3,0,.5,0,.7.1,1.4.3,2.7.9,3.8,1.7,1.2.8,2.2,1.7,3.2,2.7.5.4.9.9,1.4,1.3,1,.9,2,1.8,3.2,2.5-.5.2-1,.4-1.1.8-.1.4-.1.8-.2,1.3-.4-.4-.8-.9-1.1-1.3-.8-1.3-1.9-2.4-3.2-3.3-1.2-.9-2.5-1.8-3.7-2.7-1.1-.8-2.2-1.7-2.9-2.8,0,0,0,0-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M692.8,142c.3-.4.7-.5,1.1-.7.8-.2,1.6-.3,2.4-.3,1.4,0,2.7.2,4,.6.4.1.7.3,1,.5.4.3.3.6-.1.8-.4.2-.8.2-1.2.2-1-.2-1.9-.2-2.9-.4-1-.1-2-.2-3-.4-.4,0-.8-.2-1.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M726.9,136.2c0-.1,0-.2,0-.4-.3-.8-.5-1.7-.8-2.5-.4-1-1-2-1.8-2.9-.3-.4-.7-.7-1.2-.9,0,0-.2,0-.3,0,0,.7.2,1.4.5,2,.4.7.9,1.5,1.5,2.2.6.8,1.3,1.7,1.7,2.6,0,.1.2.2.3.4,0-.2,0-.3.1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M706.9,146.8c0,.2,0,.4,0,.7,0,.2-.2.3-.5.2,0,0-.2,0-.3-.2-.1,0-.2-.2-.3-.3-.8-.9-1.6-1.8-2.5-2.6-.1-.1-.2-.3-.3-.4-.2-.2-.2-.5,0-.7.2-.3.6-.3.9-.2.4.2.8.4,1.1.7.9.7,1.4,1.7,1.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M697.6,128.5c-.3,0-.5.2-.7.2-.4,0-.8,0-1.2,0-1,0-1.9,0-2.9,0-.4,0-.9,0-1.3-.2-.6-.1-.8-.4-.9-1,1.2-.5,6,0,6.9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M694,139.2c-.2.1-.3.2-.5.3-.7.3-1.4.5-2.1.6-1,.1-2,.3-2.9.4-.3,0-.6,0-.9,0-.2,0-.4-.2-.4-.4,0-.2.2-.3.4-.4.7-.1,1.3-.3,2-.4,1.2-.2,2.4-.3,3.5-.2.3,0,.6,0,.9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M694.5,154.6c-.2,0-.4,0-.7,0-.4,0-.5-.2-.4-.5,0,0,.1-.2.2-.3.6-.7,1.4-1.2,2.3-1.5.3,0,.5-.1.8-.1.5,0,.6.3.4.6,0,0-.1.2-.2.3-.6.4-1.2.9-1.9,1.3-.1,0-.3.1-.5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M675.5,154.9c0-.4,0-.8.4-1,.4-.2.8-.3,1.2-.4.5-.1.8,0,.9.5.2.6-.3,1.6-.9,2-.4.2-.7.2-1,0-.3-.3-.4-.6-.6-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.9,140c-.3-.6.4-1.2,1.1-1.2,0,.4-.5,1.1-1.1,1.2Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M115.9,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M121.3,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M114.3,188.3c-2.6,1.7-4.2,4.3-4.9,7.6-.1.6-.2,1.2-.2,1.8,0,2.5.9,4.6,2.6,6.4,1.7,1.8,3.8,2.8,6.4,3.1h3.6l3.5-3.5v-16.9c-1.2-.4-2.5-.5-3.8-.5-2.7,0-5.1.7-7.2,2.1ZM121.3,203.3c-.4,0-.8,0-1.3,0-1.9,0-3.4-.5-4.7-1.5-1.3-1.1-1.9-2.6-1.9-4.5s.8-4.1,2.3-5.4c1.4-1.3,3.3-1.9,5.5-1.9v13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M135.6,207.8c0,2.4-1.4,4.1-4.3,5.1-1.5.5-3.1.7-4.9.7l3.3,4c3.9-.2,6.7-1.5,8.3-3.9,1.1-1.6,1.6-3.5,1.6-5.8v-21.5l-4.1.4v21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M167.3,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M205,203.1h-8.6c.3-1.4.4-2.8.4-4.3,0-3.6-.8-6.6-2.5-9.1-1.8-2.6-4-3.9-6.8-3.9-2.7,0-4.9,1-6.4,3-.9,1.2-1.9,3.3-3,6.5-.2.6-.5,1.6-.9,2.9-.3,1.2-.6,2-.8,2.5-.6,1.6-1.4,2.5-2.4,2.5h-4.5v-16.7l-4.2.4v16.3h-7.8v-16.3c-1.3-.4-2.6-.6-3.8-.6-3.3,0-6.2,1.1-8.6,3.3-2.4,2.2-3.6,5-3.6,8.2s.9,4.6,2.6,6.4c1.7,1.8,3.8,2.8,6.4,3.1l1.1-.5c.2-.1.6-.3,1-.4.5-.2.8-.3.9-.4v2c0,2.4-1.4,4.1-4.3,5.1-1.5.5-3.1.7-4.9.7l3.3,4c3.9-.2,6.7-1.5,8.3-3.9,1.1-1.6,1.6-3.5,1.6-5.8v-.7h16.3c.7,0,1.5-.2,2.2-.8.7-.5,1.2-1.1,1.5-1.7l14.7,2.5h13.2l3.6-3.5v-26.5l-4.2.4v25.6ZM153.6,203.3c-.4,0-.8,0-1.2,0-2.3,0-4-.7-5.1-2.2-1-1.3-1.4-2.9-1.2-4.7.2-1.9,1-3.4,2.3-4.6,1.4-1.4,3.2-1.9,5.3-1.8v13.3ZM193.1,203.1l-13-2.6c1-4.6,2.5-7.8,4.3-9.5,1.6-1.5,3.2-1.7,4.9-.7,1.6.9,2.8,2.6,3.6,5.1.8,2.6.9,5.2.3,7.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "212.5 207.2 216.7 207.2 216.7 177.2 212.5 177.6 212.5 207.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M242.3,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M236.9,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M256,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M268.9,203.1h-10.6v-16.7l-4.2.4v16.3h-7.8v-16.4c-1.2-.4-2.5-.5-3.9-.5-3.3,0-6.2,1.1-8.5,3.3-2.4,2.2-3.6,4.9-3.6,8.1s.8,4.5,2.3,6.3c1.7,1.9,3.8,3,6.6,3.3h30.2l3.6-3.5v-17.2l-4.2.4v16.3ZM242.3,203.3c-.4,0-.8,0-1.2,0-1.9,0-3.5-.5-4.7-1.5-1.3-1.1-1.9-2.6-1.9-4.5s.8-4,2.3-5.4c1.4-1.2,3.3-1.9,5.5-1.9v13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M263.9,212.5c-.7,0-1.3.3-1.8.8-.5.5-.8,1.1-.8,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8s1.3-.3,1.8-.8c.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M269.6,212.5c-.7,0-1.3.3-1.8.8-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8s1.2-.3,1.8-.8c.5-.5.8-1.1.8-1.8s-.3-1.3-.8-1.8c-.5-.5-1.1-.8-1.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M328.9,203.1h-8.6c.3-1.4.4-2.8.4-4.3,0-3.6-.8-6.6-2.5-9.1-1.8-2.6-4-3.9-6.8-3.9-2.7,0-4.9,1-6.4,3-.9,1.2-1.9,3.3-3,6.5-.2.6-.5,1.6-.9,2.9-.3,1.2-.6,2-.8,2.5-.6,1.6-1.4,2.5-2.4,2.5h-4.4c.2-4.4-.9-8.1-3.2-11.2-2.4-3.2-5.7-5.1-10-5.5l-1,4.5c2.8,0,5.1,1.1,6.9,3,2,2.2,3.1,5.3,3.1,9.3h-12.9l-1.3,4.1h22.7c.7,0,1.5-.2,2.2-.8.7-.5,1.2-1.1,1.5-1.7l14.7,2.5h13.2l3.6-3.5v-26.5l-4.2.4v25.6ZM316.9,203.1l-13-2.6c1-4.6,2.5-7.8,4.3-9.5,1.6-1.5,3.2-1.7,4.9-.7,1.6.9,2.8,2.6,3.6,5.1.8,2.6.9,5.2.3,7.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "336.4 207.2 340.6 207.2 340.6 177.2 336.4 177.6 336.4 207.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M366.2,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M360.7,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M386.2,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M380.7,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M434.9,183.7c.7,0,1.3-.3,1.8-.8.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8c-.5.5-.7,1.1-.7,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M472.7,186.8v16.3h-8.6c.3-1.4.4-2.8.4-4.3,0-3.6-.8-6.6-2.5-9.1-1.8-2.6-4-3.9-6.8-3.9-2.7,0-4.9,1-6.4,3-.9,1.2-1.9,3.3-3,6.5-.2.6-.5,1.6-.9,2.9-.3,1.2-.6,2-.8,2.5-.6,1.6-1.4,2.5-2.4,2.5h-4.5v-16.7l-4.2.4v16.3h-7.7c0-.5.1-1.1.1-1.9,0-4-1.3-7.4-4-10.3-2.7-3-6-4.5-10-4.5s-8.6,2.3-11.9,6.8v-16.1l-4.2.4v25.6h-4.6v-16.4c-1.2-.4-2.5-.5-3.8-.5-3.3,0-6.2,1.1-8.5,3.3-2.4,2.2-3.6,4.9-3.6,8.1s.6,3.9,1.7,5.5h-6.3v-16.4c-1.2-.4-2.5-.5-3.9-.5-3.3,0-6.2,1.1-8.5,3.3-2.4,2.2-3.6,4.9-3.6,8.1s.8,4.5,2.3,6.3c1.7,1.9,3.8,3,6.6,3.3h78.5c.7,0,1.5-.2,2.2-.8.7-.5,1.2-1.1,1.5-1.7l14.7,2.5h13.2l3.6-3.5v-17.2l-4.2.4ZM366.2,203.3c-.4,0-.8,0-1.2,0-1.9,0-3.5-.5-4.7-1.5-1.3-1.1-1.9-2.6-1.9-4.5s.8-4,2.3-5.4c1.4-1.2,3.3-1.9,5.5-1.9v13.3ZM386.8,203.3c-.4,0-.8,0-1.3,0-1.9,0-3.4-.5-4.6-1.5-1.3-1.1-1.9-2.6-1.9-4.5s.8-4,2.3-5.4c1.4-1.3,3.3-1.9,5.5-2v13.3ZM399.4,203.1c0-3.6,1.4-6.6,3.9-9,2.3-2.2,5-3.3,8-3.3s4.9,1,6.7,2.9c2,2.2,3,5.3,3.1,9.4h-21.5ZM460.7,203.1l-13-2.6c1-4.6,2.5-7.8,4.3-9.5,1.6-1.5,3.2-1.7,4.9-.7,1.6.9,2.8,2.6,3.6,5.1.8,2.6.9,5.2.3,7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M473,212.5c-.7,0-1.4.3-1.9.8-.5.5-.8,1.1-.8,1.8s.2,1.3.7,1.8c.5.5,1.1.8,1.8.8s1.3-.3,1.8-.8c.5-.5.8-1.1.8-1.8s-.3-1.3-.8-1.8c-.5-.5-1.1-.8-1.7-.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo1);
export default __webpack_public_path__ + "static/media/MainLogo1.6de75bdf524423114c7d0904e22fac4a.svg";
export { ForwardRef as ReactComponent };